import "./Support.scss";
import { useState } from "react";
import GreenButton from "../../components/GreenButton/GreenButton";
import SupportQuestion from "./SupportQuestion";
import SupportChat from "./SupportChat";

const Support = () => {
  const [view, setView] = useState("questions");

  return (
    <div className="support">
      <div className="support-header">
        <p className="title">الدعم الفني</p>

        <div className="btns-container">
          <GreenButton
            text="الاسئلة"
            size="medium"
            variant={view === "questions" ? "fill" : "outlined"}
            onClick={() => setView("questions")}
          />
          <GreenButton
            text="رسائل الدعم"
            size="medium"
            variant={view === "support_message" ? "fill" : "outlined"}
            onClick={() => setView("support_message")}
          />
        </div>
        {view === "questions" ? <SupportQuestion /> : <SupportChat />}
      </div>
    </div>
  );
};

export default Support;
